import { Avatar, Box, Menu, Portal, Text } from '@chakra-ui/react';

import { useAuth } from '@/api/useAuth';
import { Icons } from '@/assets/Icons';
import { isExternal } from '@/components/atoms/isExternal';
import { RouterLink } from '@/components/atoms/RouterLink';
import { logoutRoute } from '@/constants';
import { userDisplayName, userInitials } from '@/entities/User';
import { settings } from '@/settings';

import { userMenuTriggerCss } from './Topbar.styles';

export const UserMenu = () => {
  const user = useAuth();
  const name = userDisplayName(user);
  const email = String(user?.get('email') ?? '');
  const canAccessAdmin = !!user?.get('is_staff');

  return (
    <Menu.Root positioning={{ placement: 'bottom-end' }}>
      <Menu.Trigger
        className="UserMenu"
        css={userMenuTriggerCss}
        aria-label={name ? `Account menu for ${name}` : 'Account menu'}
      >
        <Avatar.Root>
          <Avatar.Fallback>
            {userInitials(user) || <Icons.LuUser />}
          </Avatar.Fallback>
        </Avatar.Root>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content minWidth="56">
            <Box paddingX={2} paddingY={1.5}>
              <Text fontWeight="semibold" textStyle="sm">
                {name}
              </Text>
              {email && email !== name && (
                <Text color="fg.muted" textStyle="xs">
                  {email}
                </Text>
              )}
            </Box>
            <Menu.Separator />
            {canAccessAdmin && (
              <Menu.Item value="admin" asChild>
                <a href={settings.ADMIN_URL} {...isExternal}>
                  <Icons.LuCloudCog />
                  Super Admin
                </a>
              </Menu.Item>
            )}
            <Menu.Item value="logout" asChild>
              <RouterLink to={logoutRoute}>
                <Icons.LuLogOut />
                Log out
              </RouterLink>
            </Menu.Item>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
